import React from "react";
import PropTypes from "prop-types";


// StyleGuide = organisms/TakeQuizPage/answer-status

function AnswerStatus({
  question,
  correct = false,
  first = false,
  isSampleQuestion
}) {
  let questionType = "";
  let multipleChoice = false;

  questionType = isSampleQuestion ? question.type : question.type;
  multipleChoice = isSampleQuestion ? question.answers.filter(answer => answer.attributes.is_correct).length > 1
    : question.answers.filter(answer => answer.is_correct).length > 1;

  let alertProps = {};

  if (questionType !== 'MultipleChoiceQuestion' || multipleChoice) {
    alertProps = {
      role: 'alert',
      'aria-live': 'assertive'
    };
  }

  if (!correct) {
    return (
      <div className="AnswerStatus d-flex align-items-center ml-4">
        <div {...alertProps} className="AnswerStatus-incorrect text-red">Incorrect, try again!</div>
      </div>
    );
  }

  return (
    <div className="AnswerStatus d-flex flex-row align-items-center ml-4">
      <div {...alertProps} className={`AnswerStatus-correct pl-3 text-green ${first ? 'perfect' : ''}`}>
        {first ? 'Perfect!' : 'Correct'}
      </div>
      <div className="AnswerStatus-correct-icon">
        {first && (
          <div className="AnswerStatus-border">
            { Array(16).fill().map((_, i) => (
              <div key={i} className="AnswerStatus-border-child" />
            ))}
          </div>
        )}
        <div className="AnswerStatus-check-child AnswerStatus-check-a" />
        <div className="AnswerStatus-check-child AnswerStatus-check-b" />
      </div>
    </div>
  );
}

AnswerStatus.propTypes = {
  question: PropTypes.object.isRequired,
  first: PropTypes.bool,
  correct: PropTypes.bool,
  isSampleQuestion: PropTypes.bool
};

export default AnswerStatus;
